import { API_URLS } from 'CONFIG/API_URLS';
import Storage from 'HOC/storage';
import { STORAGE } from 'CONFIG';
import { addClassifiedToCount } from 'ACTIONS/create_classified/addClassifiedToCount';
import { CREATE_CLASSIFIED, GET_PP, PP_SAVED } from 'ACTIONS';
import { checkNested } from 'MODULES/checkNested';
import { apiAction } from 'ACTIONS/api';

import { error } from 'ACTIONS/notifications/error';
import { setIsFetching } from 'ACTIONS/ui/setIsFetching';
import forEach from 'lodash/forEach';
import omit from 'lodash/omit';
import remove from 'lodash/remove';
import size from 'lodash/size';

export const saveClassified = (v, id, onSuccess, onFailure, isEdit) => (dispatch) => {
    const url = id ? API_URLS.LOTS_BY_ID(id) : API_URLS.LOTS;
    const method = id ? 'PATCH' : 'POST';
    if (id && isEdit) {
        const lastEditedLot = Storage.get(STORAGE.lastEditedLot, true, true);
        Storage.set(STORAGE.lastEditedLot, JSON.stringify({ ...lastEditedLot, [id]: Date.now() }), true);
    }

    const postData = v;
    if (!id) {
        dispatch(addClassifiedToCount());

        const categoryHistory = Storage.get('lastInsertedCategories');
        if (!categoryHistory) {
            Storage.set('lastInsertedCategories', v.category);
        } else {
            const splitCategories = categoryHistory.split(',');
            let insertCategory = true;
            forEach(splitCategories, (c) => {
                if (c === v.category) {
                    insertCategory = false;
                }
            });
            if (insertCategory) {
                remove(splitCategories, (d, i) => i === 0);
                splitCategories.push(v.category);
            }
            Storage.set('lastInsertedCategories', splitCategories.join(','));
        }
    }
    dispatch(setIsFetching(CREATE_CLASSIFIED, true));
    // const files = pick(postData, 'files');

    let valuesToPost = omit(postData, ['files', 'flatLocation']);
    const adLocation = checkNested(valuesToPost, 'adLocation', {}) || {};
    if (adLocation.id) {
        valuesToPost = {
            ...valuesToPost,
            adLocation: {
                accurateCoordinates: adLocation.accurateCoordinates || 0,
                building: checkNested(adLocation, 'building.id') || undefined,
                street: checkNested(adLocation.street, 'id', undefined) || undefined,
                region: checkNested(adLocation.region, 'id', undefined) || undefined
            }
        };
    }
    const haveDataChanged = size(valuesToPost) > 0;
    // if (size(files) > 0 && id) {
    //     dispatch(apiAction(
    //         {
    //             url: API_URLS.LOTS_FILES(id),
    //             host: FILES_API,
    //             data: files,
    //             method: 'PATCH',
    //             onSuccess: payload => () => {
    //                 if (!haveDataChanged && onSuccess) {
    //                     onSuccess(payload.content);
    //                 }
    //             },
    //             label: UPLOAD_FILE
    //         }
    //     ));
    // }

    if (!haveDataChanged) {
        return null;
    }

    dispatch(apiAction(
        {
            url,
            method,
            auth: true,
            data: valuesToPost,
            onFailure: e => () => {
                if (onFailure) {
                    onFailure();
                }
                dispatch(error(e));
            },
            onSuccess: payload => () => {
                let address = null;
                if (checkNested(payload.content.adLocation, 'region.name')) {
                    address = `${checkNested(payload.content.adLocation, 'region.parent.parent.name', '') ? `${payload.content.adLocation.region.parent.parent.name}, ` : ''}${checkNested(payload.content.adLocation.region.parent, 'name', '') ? `${payload.content.adLocation.region.parent.name}, ` : ''}${checkNested(payload.content.adLocation.region, 'name', '') ? `${payload.content.adLocation.region.name}, ` : ''}${checkNested(payload.content.adLocation.street, 'name', '') ? `${payload.content.adLocation.street.name} ` : ''}${checkNested(payload.content.adLocation.building, 'number', '') ? `${payload.content.adLocation.building.number}` : ''}`;
                }
                dispatch({
                    type: PP_SAVED,
                    payload: payload.content,
                    address
                });
                if (window.location.pathname.indexOf(`!${payload.content.id}`) !== -1) {
                    dispatch({ type: GET_PP, payload: payload.content });
                }
                if (onSuccess) {
                    onSuccess(payload.content);
                }
            },
            label: CREATE_CLASSIFIED
        }
    ));
};
